The type of the component.

Currently, two codes are defined:

- `PrivacyConsent` which corresponds to the `DraftApplicationPrivacyConsent` type.
- `Question` which corresponds to the `DraftApplicationQuestion` type.
